<template>
    <div class="instrument">
        <div class="dashboard-header">
            <div class="welcome-bar">
                <h2 class="welcome-bar__title">欢迎回来，管理员！</h2>
                <p class="welcome-bar__desc">今日有 {{ userInfo.todayUserhome }} 个新用户注册。</p>
            </div>

            <div class="stats-card-group">
                <div v-for="(item, index) in 3" :key="index" class="stats-card">
                    <div class="stats-card_box">
                        <div class="stats-card_box__icon">
                            <img :src="index == 0 ? require('@/assets/images/index-instrument0.png') : index == 1 ? require('@/assets/images/index-instrument1.png') : index == 2 ? require('@/assets/images/index-instrument2.png') : ''"
                                alt="">
                        </div>
                        <div class="stats-card_box__content">
                            <div class="stats-card_box__content__value">{{ index == 0 ? userInfo.totalUserhome : index
                                ==
                                1 ? userInfo.totalUserhome : index == 2 ? userInfo.todayUserhomeOrder : '' }}</div>
                            <div class="stats-card_box__content__label">{{ index == 0 ? '总用户数' : index == 1 ? 'app在线' :
                                index == 2 ? '今日订单' : '' }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="function">
            <div class="function-header">
                <h3 class="function-header__title">功能模块</h3>
                <!-- <div class="function-header__more-btn" @click="handleViewAll">
                    查看全部
                    <i class="el-icon-arrow-right"></i>
                </div> -->
            </div>
            <div class="function-cards-container">
                <div v-for="(card, index) in functionCards" :key="index" class="card card--function"
                    @click="fecthFunctionCards(card)">
                    <div class="card__header">
                        <div class="card__icon">
                            <img :src="card.iconClass" alt="">
                        </div>
                        <h3 class="card__title">{{ card.title }}</h3>
                    </div>
                    <p class="card__desc">{{ card.desc }}</p>
                    <div class="card__stats">
                        <span v-for="(stat, statIndex) in card.stats" :key="statIndex" class="card__stat-item">
                            {{ stat }}
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="recent-activities">
            <!-- 标题栏 -->
            <div class="activities-header">
                <h3 class="activities-header__title">最近活动</h3>
                <!-- <div class="activities-header__more-btn" @click="handleViewAll">
                    查看全部
                    <i class="el-icon-arrow-right"></i>
                </div> -->
            </div>

            <!-- 活动列表 -->
            <div v-if="finished && activitiesData.length > 0">
                <ul class="activities-list" v-infinite-scroll="load" style="overflow:auto">
                    <li v-for="(item, index) in activitiesData" :key="index" class="activities-item"
                        @click="activitiesFecth(item)">
                        <!-- 活动图标 -->
                        <div class="activities-item__icon">
                            <img src="@/assets/images/index-instrument2.png" alt="">

                        </div>
                        <!-- 活动内容 -->
                        <div class="activities-item__content">
                            <h4 class="activities-item__content__title">{{ item.type == 1 ? '订单创建' : item.type == 2 ?
                                '订单付款' : item.type == 3 ? '售后订单创建' : item.type == 4 ? '' : '' }}</h4>
                            <p class="activities-item__content__desc">
                                <span v-if="item.type == 1 || item.type == 2 || item.type == 3">
                                    订单
                                </span>
                                <span style="margin: 0 10px;">
                                    {{ item.orderNum }}
                                </span>
                                <span>
                                    {{
                                        item.type == 1 ? '已创建，' : item.type == 2 ?
                                            '已付款，' : item.type == 3 ? '售后订单已创建，' : item.type == 4 ? '' : ''
                                    }}
                                    {{
                                        item.status == 0 ? '取消' : item.status == 1 ? '待支付' : item.status == 2 ? '待发货' :
                                            item.status == 3 ?
                                                '已发货' : item.status == 4 ? '待评价（未使用）' : item.status == 5 ? '已完成' : item.status == 6
                                                    ? '售后中' : item.status == 9 ?
                                                        '已删除（未使用）' : item.status == 10 ? '已退款' : ''

                                    }}
                                </span>
                            </p>
                            <span class="activities-item__content__time">{{ item.createTime }}</span>
                        </div>
                    </li>

                    <!-- 加载提示 -->
                    <div style="text-align:center; padding:10px; color:#999" v-if="loading">加载中...</div>
                    <div style="text-align:center; padding:10px; color:#999"
                        v-if="finished && activitiesData.length > 0">
                        没有更多了</div>
                </ul>

            </div>

            <el-empty v-if="finished && activitiesData.length == 0" description="暂无相关操作记录" :image-size="100"></el-empty>
        </div>


        <!-- 订单详情弹窗 -->
        <el-dialog title="订单详情" :visible.sync="dialogVisible" width="900px" custom-class="order-detail-dialog">
            <div class="order-detail-header">
                <div class="order-detail-header-left">
                    <span class="order-detail-no">订单号：{{ orderInfo.orderNum }}</span>
                    <el-tag :class="getStatusTagClass(orderInfo.status)">{{ getStatusText(orderInfo.status) }}</el-tag>
                </div>
                <div class="order-detail-time">下单时间：{{ orderInfo.createTime }}</div>
            </div>

            <div class="order-detail-goods-list">
                <div class="order-detail-goods-item" v-for="(item, idx) in orderInfo.userhomeOrderDetailList"
                    :key="idx">
                    <img :src="`https://api.xinshuangpai.com/jeecg-boot/sys/common/static/${item.goodUrl}`"
                        class="goods-img" alt="" @error="item.goodUrl = ''">
                    <div class="goods-detail">
                        <div class="goods-name">{{ item.goodName }} </div>
                        <div class="goods-model">数量：×{{ item.num }}</div>
                    </div>
                    <div class="goods-amount">¥{{ item.tprice }}</div>
                </div>
            </div>

            <div class="order-detail-info-group">
                <div class="info-row">
                    <div class="info-item">
                        <span class="info-label">收货人</span>
                        <el-input :value="orderInfo.userhomeAddress?.name || ''" readonly />
                    </div>
                    <div class="info-item">
                        <span class="info-label">联系电话</span>
                        <el-input :value="orderInfo.userhomeAddress?.phone || ''" readonly />
                    </div>
                </div>
                <div class="info-row">
                    <div class="info-item full-width">
                        <span class="info-label">收货地址</span>
                        <el-input
                            :value="orderInfo.userhomeAddress ? (orderInfo.userhomeAddress.areaCode + '-' + orderInfo.userhomeAddress.address) : ''"
                            readonly />
                    </div>
                </div>
            </div>

            <div class="order-detail-amount-group">
                <div class="info-row">
                    <div class="info-item">
                        <span class="info-label">商品金额</span>
                        <el-input :value="'¥' + (orderInfo.tprice || 0)" readonly />
                    </div>
                    <!-- <div class="info-item">
            <span class="info-label">运费模板</span>
            <el-input :value="orderInfo.deliveryFeeType || '偏远地区补差价'" readonly />
          </div> -->
                    <div class="info-item">
                        <span class="info-label">实际运费</span>
                        <el-input :value="'¥' + (orderInfo.deliveryFee || 0)" readonly />
                    </div>
                </div>
                <div class="info-row">
                    <div class="info-item full-width">
                        <span class="info-label">订单总额</span>
                        <el-input :value="'¥' + ((orderInfo.tprice || 0) + (orderInfo.deliveryFee || 0))" readonly
                            class="total-amount-input" />
                    </div>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="returnFecth">返回</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    instrumentHomeGet,
    instrumentHomeReadyPost
} from '@/api/index'

import {
    commerceUserhomeOrderQueryByIdGet,
    commerceUserhomeOrderListGet
} from '@/api/commerce'

export default {
    data() {
        return {
            statsList: [
            ],
            functionCards: [
                {
                    title: '用户管理',
                    iconClass: require('@/assets/images/index-instrument0.png'),
                    desc: '管理平台用户账户，查看用户信息，设置权限和角色。',
                    stats: ['12个新用户', '3个待审核'],
                    path: '/user/list',
                },
                {
                    title: '设备管理',
                    iconClass: require('@/assets/images/index-instrument1.png'),
                    desc: '查看和管理所有智能柜机设备，监控设备状态和固件版本。',
                    stats: ['356台在线', '5台异常'],
                    path: '/facility/list',
                },
                {
                    title: '安全监控',
                    iconClass: require('@/assets/images/index-instrument3.png'),
                    desc: '监控SOS事件，查看安全警报，管理紧急联系人和安全策略。',
                    stats: ['2个SOS事件', '0个未处理'],
                    path: '/safety/sos',
                },
                {
                    title: '故障排查',
                    iconClass: require('@/assets/images/index-instrument4.png'),
                    desc: '管理故障代码库，维护教程内容',
                    stats: ['2个代码已更新'],
                    path: '/fault/list',
                },
                {
                    title: '电商管理',
                    iconClass: require('@/assets/images/index-instrument2.png'),
                    desc: '管理商品和订单，处理支付和发货，查看销售数据。',
                    stats: ['89个新订单', '15个待发货'],
                    path: '/commerce/banner',
                }
            ],
            activitiesData: [],
            userInfo: {},
            page: 1,
            limit: 10,
            loading: false, // 防止重复请求
            finished: false, // 是否加载完成
            //--------------
            dialogVisible: false,
            orderInfo: {}

        }
    },
    created() {
        this.fecthInstrumentHomeGet()
    },
    methods: {
        async fecthInstrumentHomeGet() {
            // 已经加载完成 或 正在请求中，直接return
            if (this.finished || this.loading) return

            this.loading = true
            let params = {
                pageNo: this.page,
                pageSize: this.limit
            }

            try {
                const res = await instrumentHomeGet(params)
                if (res.code == 200) {
                    this.userInfo = res.result
                    const list = res.result.noticeIndex.records || []

                    // 第一页直接赋值
                    if (this.page === 1) {
                        this.activitiesData = list
                    } else {
                        // 下一页 追加数据
                        this.activitiesData = [...this.activitiesData, ...list]
                    }

                    // ✅ 关键：返回数据长度 < limit，说明没有更多了，停止加载
                    if (list.length < this.limit) {
                        this.finished = true
                    }

                    // 页码+1
                    this.page++
                }
            } catch (err) {
                console.log('请求失败', err)
            } finally {
                this.loading = false
            }
        },

        // 滚动加载
        load() {
            this.fecthInstrumentHomeGet()
        },

        handleViewAll() {
            console.log('查看全部活动');
        },

        fecthFunctionCards(item) {
            this.$router.push({
                path: item.path,
            });
        },
        activitiesFecth(item) {
            let params = {
                ids: item.id
            }


            instrumentHomeReadyPost(params).then(res => {
                if (res.code == 200) {
                    this.handleEditOrder(item.orderNum)
                }
            })
        },
        returnFecth() {
            this.dialogVisible = false

            this.page = 1
            this.finished = false
            this.fecthInstrumentHomeGet()
        },
        //-----------------
        handleEditOrder(row) {
            commerceUserhomeOrderListGet({ orderNum: row }).then(res => {
                if (res.code === 200) {
                    this.orderInfo = res.result.records[0]
                    this.dialogVisible = true
                }
            })
        },
        getStatusText(status) {
            const map = {
                0: '取消',
                1: '待支付',
                2: '等待商家发货',
                3: '商家已发货',
                4: '待评价（未使用）',
                5: '交易已完成',
                6: '售后中',
                9: '已删除（未使用）',
                10: '已完全退款'
            }
            return map[status] || '未知'
        },
        getStatusTagClass(status) {
            switch (status) {
                case 0: return 'status-tag status-reject'
                case 1: return 'status-tag status-wait'
                case 2: return 'status-tag status-processing'
                case 3: return 'status-tag status-shipped'
                case 4: return 'status-tag status-processing'
                case 5: return 'status-tag status-done'
                case 6: return 'status-tag status-auto'
                case 9: return 'status-tag status-reject'
                case 10: return 'status-tag status-reject'
                default: return 'status-tag'
            }
        },
        getShouhouStatusText(val) {
            const map = {
                0: '未处理',
                1: '处理中',
                2: '已驳回',
                3: '自动处理',
                4: '已处理',
                5: '已撤销'
            }
            return map[val] || '未知'
        },
    }
}
</script>


<style lang="less" scoped>
@import url('./instrument.less');

.instrument {
    padding-bottom: 40px;
    box-sizing: border-box;

    .dashboard-header {

        // 欢迎栏
        .welcome-bar {
            background: @welcome-bar-bg;
            color: @welcome-bar-text;
            padding: @stats-padding;
            border-radius: 8px;
            margin-bottom: @stats-gap;

            &__title {
                font-size: 20px;
                font-weight: 600;
                margin: 0 0 12px 0;
            }

            &__desc {
                font-size: 12px;
                margin: 0;
                opacity: 0.9;
            }
        }

        // 统计卡片组
        .stats-card-group {
            display: flex;
            gap: @stats-gap;
            flex-wrap: wrap; // 响应式换行

            .stats-card {
                background: #3B7AFF;
                border-radius: 8px;
                flex: 1;
                min-width: 180px; // 最小宽度保证适配
                display: flex;
                align-items: center;
                position: relative;
                padding-left: 4px;
                box-sizing: border-box;

                &_box {
                    background: @stats-card-bg;
                    border: 1px solid @stats-card-border;
                    border-radius: 8px;
                    padding: @stats-padding;
                    flex: 1;
                    min-width: 180px; // 最小宽度保证适配
                    display: flex;
                    align-items: center;
                    gap: 12px;

                    &__icon {
                        width: 50px;
                        height: 50px;
                        background: #e6f0ff;
                        color: @welcome-bar-bg;
                        border-radius: 6px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 14px;

                        img {
                            width: 30px;
                            height: 30px;
                            object-fit: contain;
                        }
                    }

                    &__content {
                        &__value {
                            font-size: 20px;
                            font-weight: 700;
                            color: @stats-card-value-color;
                            margin-bottom: 4px;
                        }

                        &__label {
                            font-size: 12px;
                            color: @stats-card-label-color;
                        }
                    }
                }


            }
        }
    }


    .function {
        margin-top: 16px;

        .function-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: @btn-padding;
            border-radius: 8px;
            margin-bottom: 16px;

            &__title {
                font-size: 15px;
                font-weight: 600;
                color: @title-color;
                margin: 0;
            }

            &__more-btn {
                display: flex;
                align-items: center;
                gap: 4px;
                background: transparent;
                border: none;
                color: @btn-color;
                font-size: 12px;
                cursor: pointer;
                padding: 4px 0;
                transition: color 0.2s;
                font-weight: bold;

                &:hover {
                    color: @btn-hover-color;
                }

                .icon-arrow {
                    font-size: 10px;
                }
            }
        }

        .function-cards-container {
            display: flex;
            flex-wrap: wrap;
            gap: @card-gap;

            .card--function {
                width: calc((100% / 4) - 20px);
                padding: @card-padding;
                background: #fff;
                border-radius: 8px;
                box-shadow: 0 2px 8px @shadow-color;
                transition: transform 0.2s;
                box-sizing: border-box;

                &:hover {
                    transform: translateY(-3px);
                }

                .card__header {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    margin-bottom: 12px;

                    .card__icon {
                        width: 40px;
                        height: 40px;
                        background: #EBF1FF;
                        border-radius: 4px;
                        color: #fff;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        img {
                            width: 25px;
                            height: 25px;
                        }
                    }

                    .card__title {
                        font-size: @title-font-size;
                        font-weight: 600;
                        color: @text-color-main;
                        margin: 0;
                    }
                }

                .card__desc {
                    font-size: @desc-font-size;
                    color: @text-color-secondary;
                    line-height: 1.5;
                    margin-bottom: 16px;
                    height: @desc-height;
                    overflow: hidden;
                }

                .card__stats {
                    display: flex;
                    font-size: @desc-font-size;
                    color: @text-color-secondary;
                    line-height: 1.5;
                    justify-content: space-between;

                }
            }

        }
    }

    .recent-activities {
        background: #fff;
        border-radius: 8px;
        padding: @recent-padding;
        margin-top: 16px;

        // 标题栏
        .activities-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 16px;

            &__title {
                font-size: 15px;
                font-weight: 600;
                color: @recent-text-main;
                margin: 0;
            }

            &__more-btn {
                color: @recent-primary-color;
                background: transparent;
                border: none;
                font-size: 14px;
                cursor: pointer;
                display: flex;
                align-items: center;
                gap: 4px;

                .icon-arrow {
                    font-size: 10px;
                }
            }
        }

        // 活动列表
        .activities-list {
            list-style: none;
            padding: 0;
            margin: 0;
            min-height: 100px;
            max-height: 400px;


            // 活动项
            .activities-item {
                display: flex;
                align-items: flex-start;
                gap: @recent-gap;
                padding: 12px 0;
                border-bottom: 1px solid #f5f5f5;
                cursor: pointer;

                &:last-child {
                    border-bottom: none;
                }

                // 活动图标
                &__icon {
                    width: 40px;
                    height: 40px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #fff;
                    background: #ECF1FF;
                    border-radius: 50%;

                    img {
                        width: 20px;
                        height: 20px;
                        object-fit: contain;
                    }
                }

                // 活动内容
                &__content {
                    flex: 1;


                    &__title {
                        font-size: @title-font-size;
                        font-weight: 600;
                        color: @text-color-main;
                        margin: 0 0 8px 0;
                    }

                    &__desc {
                        font-size: @desc-font-size;
                        color: @text-color-secondary;
                        line-height: 1.5;
                        margin-bottom: 10px;

                    }

                    &__time {
                        font-size: @desc-font-size;
                        color: @text-color-secondary;
                    }
                }

            }
        }

    }



    .order-detail-dialog {
        padding: 10px 0;

        .order-detail-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;
            padding-bottom: 10px;
            border-bottom: 1px solid #eee;

            .order-detail-header-left {
                display: flex;
                align-items: center;
                gap: 10px;
                font-size: 16px;
                font-weight: 600;
            }

            .order-detail-time {
                font-size: 14px;
                color: #666;
            }
        }

        .order-detail-goods-list {
            margin-bottom: 20px;

            .order-detail-goods-item {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 10px 0;

                .goods-img {
                    width: 60px;
                    height: 60px;
                    border-radius: 4px;
                    margin-right: 15px;
                }

                .goods-detail {
                    flex: 1;

                    .goods-name {
                        font-size: 14px;
                        color: #333;
                        font-weight: 500;
                    }

                    .goods-model {
                        font-size: 12px;
                        color: #999;
                        margin-top: 4px;
                    }
                }

                .goods-amount {
                    font-size: 16px;
                    color: #ff4d4f;
                    font-weight: 600;
                }
            }
        }

        .order-detail-info-group,
        .order-detail-amount-group {
            margin-bottom: 20px;

            .info-row {
                display: flex;
                gap: 20px;
                margin-bottom: 15px;

                .info-item {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    gap: 5px;

                    &.full-width {
                        flex: 1 1 100%;
                    }

                    .info-label {
                        font-size: 14px;
                        color: #333;
                        font-weight: 500;
                    }

                    /deep/ .el-input__inner {
                        background: #f5f7fa;
                        border: 1px solid #eee;
                        border-radius: 4px;
                        font-size: 14px;
                    }
                }
            }
        }

        .total-amount-input {
            /deep/ .el-input__inner {
                color: #ff4d4f;
                font-weight: 600;
                font-size: 16px;
            }
        }
    }
}
</style>